import { useQuery } from "@tanstack/react-query";
import { api } from "lib/api";

export function usePerfilContext(enabled = true) {
  return useQuery({
    queryKey: ["perfil", "context"],
    queryFn: () => api("/perfil/context"),
    enabled,
    staleTime: 60_000,
  });
}
